import React from "react";

import { useTheme } from '@mui/material/styles';

function BellIcon({ dot = false }) {
    const theme = useTheme();

    const color = theme.palette.icons.color;

    return (
        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_472_3774)">
                <path fillRule="evenodd" clipRule="evenodd" d="M18.597 8.97022C18.2581 5.58099 15.4061 3 12 3V3C8.59387 3 5.7419 5.58099 5.40298 8.97022L5.10489 11.9511C5.03959 12.6041 4.64411 13.1779 4.05719 13.4714L4.02492 13.4875C3.39678 13.8016 3 14.4436 3 15.1459V15.1459C3 16.1699 3.83011 17 4.8541 17H19.1459C20.1699 17 21 16.1699 21 15.1459V15.1459C21 14.4436 20.6032 13.8016 19.9751 13.4875L19.9428 13.4714C19.3559 13.1779 18.9604 12.6041 18.8951 11.9511L18.597 8.97022Z" stroke={color} strokeWidth="2"/>
                <path d="M15 20C15 20 14 22 12 22C10 22 9 20 9 20" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                {dot && <circle className="transition" cx="20" cy="4" r="5" fill="#F16868" stroke={theme.palette.background.navbarButton} strokeWidth="2"/>}
            </g>
            <defs>
                <clipPath id="clip0_472_3774">
                    <rect width="24" height="24" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
}

export default BellIcon;
